// src/services/singleValueListService.js

import { repo } from "../dbservice/repo";
import { SingleValueListModel } from "../models/SingleValueListModel";

// ── Static fallback catalog ──
export const STATIC_FALLBACK_LISTS = [
  {
    id: "svl-units-of-measurement",
    name: "units_of_measurement",
    descriptions: "Units of Measurement",
    scope: "system",
    companyId: "",
    userId: null,
    items: [
      { label: "Pieces",     value: "pieces" },
      { label: "Litres",     value: "litres" },
      { label: "Kilograms",  value: "kg" },
      { label: "Metres",     value: "metres" },
      { label: "Boxes",      value: "boxes" },
      { label: "Packs",      value: "packs" },
      { label: "Reams",      value: "reams" },
      { label: "Cartridges", value: "cartridges" },
      { label: "Licenses",   value: "licenses" },
      { label: "Units",      value: "units" },
    ],
    metadata: { createdAt: null, updatedAt: null, deletedFlag: false },
  },
  {
    id: "svl-maintenance-intervals",
    name: "maintenance_intervals",
    descriptions: "Maintenance Intervals",
    scope: "system",
    companyId: "",
    userId: null,
    items: [
      { label: "Weekly",       value: "weekly" },
      { label: "Monthly",      value: "monthly" },
      { label: "Quarterly",    value: "quarterly" },
      { label: "Half Yearly",  value: "half-yearly" },
      { label: "Yearly",       value: "yearly" },
      { label: "On-Demand",    value: "on-demand" },
    ],
    metadata: { createdAt: null, updatedAt: null, deletedFlag: false },
  },
  {
    id: "svl-disposal-reasons",
    name: "disposal_reasons",
    descriptions: "Disposal Reasons",
    scope: "system",
    companyId: "",
    userId: null,
    items: [
      { label: "Damaged / Beyond Repair", value: "damaged-beyond-repair" },
      { label: "End of Life / Obsolete",  value: "end-of-life-obsolete" },
      { label: "Lost / Stolen",           value: "lost-stolen" },
      { label: "Sold / Auctioned",        value: "sold-auctioned" },
      { label: "Donated",                 value: "donated" },
      { label: "Scrapped / Recycled",     value: "scrapped-recycled" },
      { label: "Written Off",             value: "written-off" },
      { label: "Other",                   value: "other" },
    ],
    metadata: { createdAt: null, updatedAt: null, deletedFlag: false },
  },
  {
    id: "svl-user-roles",
    name: "user_roles",
    descriptions: "System User Roles",
    scope: "system",
    companyId: "",
    userId: null,
    items: [
      { label: "Super Admin",    value: "superadmin" },
      { label: "Admin",          value: "admin" },
      { label: "Location Admin", value: "locationAdmin" },
      { label: "Auditor",        value: "auditor" },
      { label: "Technician",     value: "technician" },
      { label: "User",           value: "user" },
    ],
    metadata: { createdAt: null, updatedAt: null, deletedFlag: false },
  },
  {
    id: "svl-asset-types",
    name: "asset_types",
    descriptions: "Asset Hierarchy Classification",
    scope: "system",
    companyId: "",
    userId: null,
    items: [
      { label: "Primary",   value: "Primary" },
      { label: "Parent Asset", value: "Parent" },
      { label: "Sub Asset",    value: "Sub Asset" },
      { label: "Customer", value: "Customer" },
      { label: "Component",    value: "Component" },
      { label: "Accessory",    value: "Accessory" },
    ],
    metadata: { createdAt: null, updatedAt: null, deletedFlag: false },
  },
  {
    id: "svl-ownership-types",
    name: "ownership_types",
    descriptions: "Asset Ownership & Procurement Types",
    scope: "system",
    companyId: "",
    userId: null,
    items: [
      { label: "Owned",  value: "Owned" },
      { label: "Leased", value: "Leased" },
      { label: "Rented", value: "Rented" },
    ],
    metadata: { createdAt: null, updatedAt: null, deletedFlag: false },
  },
  {
    id: "svl-asset-statuses",
    name: "asset_statuses",
    descriptions: "Asset Operating Statuses",
    scope: "system",
    companyId: "",
    userId: null,
    items: [
      { label: "Available",         value: "Available" },
      { label: "Assigned / In Use", value: "Assigned" },
      { label: "In Maintenance",    value: "In Maintenance" },
      { label: "Under Repair",      value: "Under Repair" },
      { label: "Reserved",          value: "Reserved" },
      { label: "Disposed",          value: "Disposed" },
      { label: "Lost / Stolen",     value: "Lost" },
    ],
    metadata: { createdAt: null, updatedAt: null, deletedFlag: false },
  },
  {
    id: "svl-serialization-types",
    name: "serialization_types",
    descriptions: "Inventory Tracking Methods",
    scope: "system",
    companyId: "",
    userId: null,
    items: [
      { label: "Serialized",     value: "serialized" },
      { label: "Non-Serialized", value: "non-serialized" },
    ],
    metadata: { createdAt: null, updatedAt: null, deletedFlag: false },
  },
  {
    id: "svl-depreciation-methods",
    name: "depreciation_methods",
    descriptions: "Depreciation Methods",
    scope: "system",
    companyId: "",
    userId: null,
    items: [
      { label: "Straight Line Method (SLM)", value: "SLM" },
      { label: "Written Down Value (WDV)",   value: "WDV" },
      { label: "None / Not Depreciable",     value: "None" },
    ],
    metadata: { createdAt: null, updatedAt: null, deletedFlag: false },
  },
  {
    id: "svl-billing-frequencies",
    name: "billing_frequencies",
    descriptions: "Lease and Rental Billing Frequencies",
    scope: "system",
    companyId: "",
    userId: null,
    items: [
      { label: "Monthly",     value: "monthly" },
      { label: "Quarterly",   value: "quarterly" },
      { label: "Half Yearly", value: "half-yearly" },
      { label: "Yearly",      value: "yearly" },
      { label: "One-Time",    value: "one-time" },
    ],
    metadata: { createdAt: null, updatedAt: null, deletedFlag: false },
  },
  {
    id: "svl-approvers",
    name: "approvers",
    scope: "system",
    companyId: "",
    userId: null,
    items: [],
    metadata: { createdAt: null, updatedAt: null, deletedFlag: false },
  },
  {
    id: "svl-audit-verification-statuses",
    name: "audit_verification_statuses",
    scope: "system",
    companyId: "",
    userId: null,
    items: [
      { label: "Pending",  value: "pending"  },
      { label: "Verified", value: "verified" },
      { label: "Missing",  value: "missing"  },
      { label: "Shifted",  value: "shifted"  },
    ],
    metadata: { createdAt: null, updatedAt: null, deletedFlag: false },
  },
  // ─────────────────────────────────────────────────────────────
  //  TICKET / ISSUE CATALOGUE
  // ─────────────────────────────────────────────────────────────
  {
    id: "svl-ticket-issue-types",
    name: "ticket_issue_types",
    scope: "system",
    companyId: "",
    userId: null,
    items: [
      { label: "Asset Issue",      value: "Asset"    },
      { label: "Account Problem",  value: "Account"  },
      { label: "Access Request",   value: "Access"   },
      { label: "Software Problem", value: "Software" },
      { label: "Other",            value: "Other"    },
    ],
    metadata: { createdAt: null, updatedAt: null, deletedFlag: false },
  },
  {
    id: "svl-audit-issue-types",
    name: "audit_issue_types",
    scope: "system",
    companyId: "",
    userId: null,
    items: [
      { label: "Missing Asset",           value: "Missing Asset"   },
      { label: "Damaged Asset",           value: "Damaged Asset"   },
      { label: "Misplaced Asset",         value: "Misplaced Asset" },
      { label: "Asset in Wrong Location", value: "Wrong Location"  },
      { label: "QR Code Not Working",     value: "QR Code Issue"   },
      { label: "Data Discrepancy",        value: "Data Discrepancy"},
      { label: "Other Audit Issue",       value: "Other"           },
    ],
    metadata: { createdAt: null, updatedAt: null, deletedFlag: false },
  },

  // ─────────────────────────────────────────────────────────────
  //  TICKET RECEIVERS  (roles that can receive tickets — multi-select)
  //  "User" is intentionally excluded from the options.
  // ─────────────────────────────────────────────────────────────
  {
    id: "svl-ticket-receivers",
    name: "ticket_receivers",
    descriptions: "Roles that can receive tickets",
    scope: "system",
    companyId: "",
    userId: null,
    items: [
      { label: "Admin",          value: "admin" },
      { label: "Location Admin", value: "locationAdmin" },
      { label: "Auditor",        value: "auditor" },
      { label: "Technician",     value: "technician" },
    ],
    metadata: { createdAt: null, updatedAt: null, deletedFlag: false },
  },

  {
    id: "svl-ticket-priorities",
    name: "ticket_priorities",
    scope: "system",
    companyId: "",
    userId: null,
    items: [
      { label: "Low",      value: "Low"      },
      { label: "Medium",   value: "Medium"   },
      { label: "High",     value: "High"     },
      { label: "Critical", value: "Critical" },
    ],
    metadata: { createdAt: null, updatedAt: null, deletedFlag: false },
  },
  {
    id: "svl-ticket-statuses",
    name: "ticket_statuses",
    scope: "system",
    companyId: "",
    userId: null,
    items: [
      { label: "Open",        value: "Open"        },
      { label: "In Progress", value: "In Progress" },
      { label: "Resolved",    value: "Resolved"    },
      { label: "Closed",      value: "Closed"      },
    ],
    metadata: { createdAt: null, updatedAt: null, deletedFlag: false },
  },
];

// ── Naming constants ────────────────────────────────────────
export const ASSET_OWNER_BYPASS_LIST_NAME = "AssetOwner";
export const APPROVER_LIST_NAME = "approvers";
export const AUDIT_VERIFICATION_STATUSES_LIST_NAME = "audit_verification_statuses";

// Fixed approval statuses that are never part of the SVL (system-managed)
export const APPROVAL_STATUS_CREATED    = "Created";
export const APPROVAL_STATUS_APPROVED   = "Approved";
export const APPROVAL_STATUS_CORRECTION = "Correction";
export const APPROVAL_STATUS_REJECTED   = "Rejected";

export const TICKET_ISSUE_TYPES_LIST_NAME      = "ticket_issue_types";
export const AUDIT_ISSUE_TYPES_LIST_NAME       = "audit_issue_types";
export const TICKET_ASSET_REQUIRED_LIST_NAME   = "ticket_asset_required_for";
export const TICKET_PRIORITIES_LIST_NAME       = "ticket_priorities";
export const TICKET_PRIORITY_MAPPING_LIST_NAME = "ticket_priority_mapping";
export const TICKET_STATUSES_LIST_NAME         = "ticket_statuses";

// ── Ticket Receivers (roles that can receive tickets) ──────
export const TICKET_RECEIVERS_LIST_NAME = "ticket_receivers";

// Roles that are NEVER valid ticket receivers (excluded by definition)
export const NON_RECEIVER_ROLES = Object.freeze(["user"]);

// Roles that may be configured as receivers (multi-select source)
export const RECEIVER_ROLE_OPTIONS = Object.freeze([
  { label: "Admin",          value: "admin" },
  { label: "Location Admin", value: "locationAdmin" },
  { label: "Auditor",        value: "auditor" },
  { label: "Technician",     value: "technician" },
]);

/** True when a list is the Ticket Receivers catalog. */
export const isTicketReceiversList = (list) => {
  if (!list) return false;
  const name = String(list.name || "").toLowerCase();
  const id = String(list.id || "").toLowerCase();
  return name === TICKET_RECEIVERS_LIST_NAME || id.includes("ticket-receivers");
};

// Helper to reliably identify approver lists.
export const isApproverList = (list) => {
  if (!list) return false;
  const name = String(list.name || "").toLowerCase();
  const id = String(list.id || "").toLowerCase();
  return (
    name === "approver" ||
    name === "approvers" ||
    id.includes("approver")
  );
};

class SingleValueListService {
  constructor() {
    this.collectionName = "single-value-lists";
  }

  get currentUser() {
    if (typeof window === "undefined" || !window.localStorage) return null;
    const data = localStorage.getItem("userData");
    try {
      return data ? JSON.parse(data) : null;
    } catch (e) {
      console.error("Failed to parse userData from localStorage", e);
      return null;
    }
  }

  _filterFallbacks({ companyId = null, scope = null, userId = null, name = null } = {}) {
    return STATIC_FALLBACK_LISTS.filter((list) => {
      if (scope && list.scope !== scope) return false;

      if (list.scope !== "system") {
        if (companyId && list.companyId !== companyId) return false;
        if (userId && list.userId !== userId) return false;
      }

      if (
        name &&
        typeof name === "string" &&
        name.trim() !== "" &&
        list.name.toLowerCase() !== name.trim().toLowerCase()
      ) {
        return false;
      }
      return true;
    });
  }

  // ── READ ───────────────────────────────────────────────────
  async getListById(listId) {
    if (!listId) throw new Error("List ID is required");

    try {
      const doc = await repo.fetchById(this.collectionName, listId);
      if (doc) return new SingleValueListModel(doc);
    } catch (err) {
      console.warn(
        "[SingleValueListService] DB read failed, checking static Match:",
        err,
      );
    }

    const staticMatch = STATIC_FALLBACK_LISTS.find(
      (item) =>
        item.id === listId ||
        item.name.toLowerCase() === String(listId).toLowerCase(),
    );
    return staticMatch ? new SingleValueListModel(staticMatch) : null;
  }

  async getLists({ companyId = null, scope = null, userId = null, name = null } = {}) {
    const user = this.currentUser;

    if (companyId === null) companyId = user?.companyId || "";
    if (userId === null && scope === "user") userId = user?.id || user?.uid || "";

    const query = { companyId, scope, userId, name };

    try {
      const filters = [];
      if (companyId) filters.push({ field: "companyId", value: companyId });
      if (scope) filters.push({ field: "scope", value: scope });
      if (userId) filters.push({ field: "userId", value: userId });
      if (name && String(name).trim() !== "")
        filters.push({ field: "name", value: name.trim() });

      const rawDocs = await repo.fetchData(this.collectionName, filters);

      const dbLists = (Array.isArray(rawDocs) ? rawDocs : [])
        .map((doc) => new SingleValueListModel(doc))
        .filter((l) => l.metadata?.deletedFlag !== true);

      const dbNames = new Set(dbLists.map((l) => l.name.toLowerCase()));
      const missingFallbacks = this._filterFallbacks(query)
        .filter((fb) => !dbNames.has(fb.name.toLowerCase()))
        .map((fb) => new SingleValueListModel(fb));

      return [...dbLists, ...missingFallbacks];
    } catch (err) {
      console.error(
        "[SingleValueListService] getLists failed — returning statics:",
        err,
      );
      return this._filterFallbacks(query).map(
        (fb) => new SingleValueListModel(fb),
      );
    }
  }

  async getItems(name, { companyId = null, scope = null, userId = null } = {}) {
    const lists = await this.getLists({ companyId, scope, userId, name });
    const match = lists.find(
      (l) => l.name.toLowerCase() === String(name).toLowerCase(),
    );
    return match?.items || [];
  }

  // ── WRITE ──────────────────────────────────────────────────
  async upsertList(listId, data, { isCreation = false } = {}) {
    if (!listId) throw new Error("List ID is required");

    const instance = new SingleValueListModel(
      { ...data, id: listId },
      { isCreation },
    );

    if (!instance.isValid({ isCreation })) {
      throw new Error(
        "Invalid single value list: name, scope, and non-empty items are required.",
      );
    }

    const payload = instance.toPayload();
    const now = new Date().toISOString();
    const actor = this.currentUser?.email || "system";

    payload.metadata = {
      ...(payload.metadata || {}),
      updatedAt: now,
      modifiedBy: actor,
    };
    if (isCreation) {
      payload.metadata.createdAt = now;
      payload.metadata.createdBy = actor;
      payload.metadata.deletedFlag = false;
    }

    return await repo.upsertData(this.collectionName, listId, payload);
  }

  async deleteList(listId) {
    if (!listId) throw new Error("List ID is required");

    const existing = await repo.fetchById(this.collectionName, listId);
    if (!existing) throw new Error("List not found.");

    if (existing.scope === "system") {
      throw new Error(
        "System lists cannot be deleted. Create a company override instead.",
      );
    }

    const now = new Date().toISOString();
    const actor = this.currentUser?.email || "system";

    await repo.upsertData(this.collectionName, listId, {
      ...existing,
      metadata: {
        ...(existing.metadata || {}),
        deletedFlag: true,
        updatedAt: now,
        modifiedBy: actor,
      },
    });

    return { success: true };
  }

  // ── Asset Ownership helpers ────────────────────────────────

  async getAssetOwnerBypassList(companyId = null) {
    const user = this.currentUser;
    if (!companyId) companyId = user?.companyId || "";
    if (!companyId) return [];

    try {
      const lists = await this.getLists({
        companyId,
        name: ASSET_OWNER_BYPASS_LIST_NAME,
      });

      const match = lists.find(
        (l) => l.name.toLowerCase() === ASSET_OWNER_BYPASS_LIST_NAME.toLowerCase(),
      );
      if (!match) return [];

      return (match.items || [])
        .map((it) => String(it.value || it.label || "").trim().toLowerCase())
        .filter((email) => email.includes("@"));
    } catch (err) {
      console.error("[SingleValueListService] getAssetOwnerBypassList failed:", err);
      return [];
    }
  }

  async setAssetOwnerBypassList(emails = [], companyId = null) {
    const user = this.currentUser;
    if (!companyId) companyId = user?.companyId || "";
    if (!companyId) throw new Error("Company ID is required.");

    const cleanEmails = Array.from(
      new Set(
        (Array.isArray(emails) ? emails : [])
          .map((e) => String(e || "").trim().toLowerCase())
          .filter((e) => e.includes("@")),
      ),
    );

    const listId = `svl-asset-owner-bypass-${companyId}`;

    const payload = {
      id: listId,
      companyId,
      userId: null,
      scope: "company",
      name: ASSET_OWNER_BYPASS_LIST_NAME,
      descriptions: "Users allowed to view/edit assets they do not own",
      items: cleanEmails.map((email) => ({ label: email, value: email })),
      metadata: {
        deletedFlag: false,
        createdBy: user?.email || "system",
        modifiedBy: user?.email || "system",
      },
    };

    return await this.upsertList(listId, payload, { isCreation: true });
  }

  // ── Ticket / Issue helpers ─────────────────────────────────

  async getTicketIssueTypes({ companyId = null } = {}) {
    try {
      const items = await this.getItems(TICKET_ISSUE_TYPES_LIST_NAME, { companyId });
      return Array.isArray(items) ? items : [];
    } catch (err) {
      console.error("[SingleValueListService] getTicketIssueTypes failed:", err);
      const fb = STATIC_FALLBACK_LISTS.find((l) => l.name === TICKET_ISSUE_TYPES_LIST_NAME);
      return fb?.items || [];
    }
  }

  async getAuditIssueTypes({ companyId = null } = {}) {
    try {
      const items = await this.getItems(AUDIT_ISSUE_TYPES_LIST_NAME, { companyId });
      return Array.isArray(items) ? items : [];
    } catch (err) {
      console.error("[SingleValueListService] getAuditIssueTypes failed:", err);
      const fb = STATIC_FALLBACK_LISTS.find((l) => l.name === AUDIT_ISSUE_TYPES_LIST_NAME);
      return fb?.items || [];
    }
  }

  async getTicketAssetRequiredFor({ companyId = null } = {}) {
    try {
      const items = await this.getItems(TICKET_ASSET_REQUIRED_LIST_NAME, { companyId });
      return (Array.isArray(items) ? items : [])
        .map((it) => String(it.value || it.label || "").trim())
        .filter(Boolean);
    } catch (err) {
      console.error("[SingleValueListService] getTicketAssetRequiredFor failed:", err);
      const fb = STATIC_FALLBACK_LISTS.find((l) => l.name === TICKET_ASSET_REQUIRED_LIST_NAME);
      return (fb?.items || [])
        .map((it) => String(it.value || it.label || "").trim())
        .filter(Boolean);
    }
  }

  async isAssetRequiredForIssue(issueType, { companyId = null } = {}) {
    const needle = String(issueType || "").trim().toLowerCase();
    if (!needle) return false;
    const required = await this.getTicketAssetRequiredFor({ companyId });
    return required.some((v) => String(v).trim().toLowerCase() === needle);
  }

  async getTicketStatuses({ companyId = null } = {}) {
    try {
      const items = await this.getItems(TICKET_STATUSES_LIST_NAME, { companyId });
      return Array.isArray(items) ? items : [];
    } catch (err) {
      console.error("[SingleValueListService] getTicketStatuses failed:", err);
      const fb = STATIC_FALLBACK_LISTS.find((l) => l.name === TICKET_STATUSES_LIST_NAME);
      return fb?.items || [];
    }
  }

  async getTicketPriorities({ companyId = null } = {}) {
    try {
      const items = await this.getItems(TICKET_PRIORITIES_LIST_NAME, { companyId });
      return Array.isArray(items) ? items : [];
    } catch (err) {
      console.error("[SingleValueListService] getTicketPriorities failed:", err);
      const fb = STATIC_FALLBACK_LISTS.find((l) => l.name === TICKET_PRIORITIES_LIST_NAME);
      return fb?.items || [];
    }
  }

  async getTicketPriorityMapping({ companyId = null } = {}) {
    try {
      const items = await this.getItems(TICKET_PRIORITY_MAPPING_LIST_NAME, { companyId });
      const map = {};
      for (const it of Array.isArray(items) ? items : []) {
        const key = String(it.label || "").trim();
        const val = String(it.value || "").trim();
        if (key && val) map[key] = val;
      }
      return map;
    } catch (err) {
      console.error("[SingleValueListService] getTicketPriorityMapping failed:", err);
      const fb = STATIC_FALLBACK_LISTS.find((l) => l.name === TICKET_PRIORITY_MAPPING_LIST_NAME);
      const map = {};
      for (const it of fb?.items || []) {
        const key = String(it.label || "").trim();
        const val = String(it.value || "").trim();
        if (key && val) map[key] = val;
      }
      return map;
    }
  }

  async getDefaultPriorityForIssue(issueType, { companyId = null, fallback = "Medium" } = {}) {
    const key = String(issueType || "").trim();
    if (!key) return fallback;
    const map = await this.getTicketPriorityMapping({ companyId });
    const found =
      map[key] ??
      Object.entries(map).find(
        ([k]) => k.toLowerCase() === key.toLowerCase(),
      )?.[1];
    return found || fallback;
  }

  // ── Ticket Receiver helpers (roles that can receive tickets) ──

  /**
   * Returns the configured receiver roles (as lowercase role keys).
   * Falls back to defaults if the company list is empty.
   * "User" is always excluded.
   */
  async getTicketReceiverRoles({ companyId = null } = {}) {
    const sanitize = (items) =>
      (Array.isArray(items) ? items : [])
        .map((it) => String(it.value || it.label || "").trim().toLowerCase())
        .filter((r) => r && !NON_RECEIVER_ROLES.includes(r));

    try {
      const items = await this.getItems(TICKET_RECEIVERS_LIST_NAME, { companyId });
      const roles = sanitize(items);
      if (roles.length > 0) return roles;
      // Empty → fall back to the default catalog
      const fb = STATIC_FALLBACK_LISTS.find((l) => l.name === TICKET_RECEIVERS_LIST_NAME);
      return sanitize(fb?.items || []);
    } catch (err) {
      console.error("[SingleValueListService] getTicketReceiverRoles failed:", err);
      const fb = STATIC_FALLBACK_LISTS.find((l) => l.name === TICKET_RECEIVERS_LIST_NAME);
      return sanitize(fb?.items || []);
    }
  }

  /**
   * Persist receiver roles (multi-select of role keys, e.g. ["admin","technician"]).
   * "User" is always filtered out.
   */
  async setTicketReceiverRoles(roles = [], companyId = null) {
    const user = this.currentUser;
    if (!companyId) companyId = user?.companyId || "";
    if (!companyId) throw new Error("Company ID is required.");

    const cleanRoles = Array.from(
      new Set(
        (Array.isArray(roles) ? roles : [])
          .map((r) => String(r || "").trim().toLowerCase())
          .filter((r) => r && !NON_RECEIVER_ROLES.includes(r)),
      ),
    );

    const listId = `svl-ticket-receivers-${companyId}`;

    const payload = {
      id: listId,
      companyId,
      userId: null,
      scope: "company",
      name: TICKET_RECEIVERS_LIST_NAME,
      descriptions: "Roles that can receive tickets",
      items: cleanRoles.map((r) => {
        const opt = RECEIVER_ROLE_OPTIONS.find(
          (o) => o.value.toLowerCase() === r,
        );
        return { label: opt?.label || r, value: r };
      }),
      metadata: {
        deletedFlag: false,
        createdBy: user?.email || "system",
        modifiedBy: user?.email || "system",
      },
    };

    return await this.upsertList(listId, payload, { isCreation: true });
  }

   async isRoleAllowedAsReceiver(role, { companyId = null } = {}) {
    const key = String(role || "").trim().toLowerCase();
    if (!key) return false;
    if (NON_RECEIVER_ROLES.includes(key)) return false;
    const allowed = await this.getTicketReceiverRoles({ companyId });
    return allowed.includes(key);
  }

  /**
   * Predicate: is the given user allowed to be assigned to a ticket
   * raised by `raisedByRole`?
   *
   * Empty / missing configured list → unrestricted (returns true).
   * Fail-open: any read error → returns true.
   */
  async isAssigneeAllowedForRole(raisedByRole, { uid = "", email = "" } = {}, { companyId = null } = {}) {
    const roleKey = String(raisedByRole || "").trim().toLowerCase();
    if (!roleKey) return true;
    if (!uid && !email) return true;

    try {
      const items = await this.getItems(
        `assignees_${roleKey}`,
        { companyId },
      );
      if (!Array.isArray(items) || items.length === 0) return true;

      const needleUid   = String(uid || "").trim();
      const needleEmail = String(email || "").trim().toLowerCase();

      return items.some((it) => {
        const v = it?.value;
        if (v && typeof v === "object") {
          if (needleUid && v.uid && String(v.uid) === needleUid) return true;
          if (needleEmail && v.email && String(v.email).toLowerCase() === needleEmail) return true;
          return false;
        }
        const s = String(v || it?.label || "").trim().toLowerCase();
        if (!s) return false;
        if (needleEmail && s === needleEmail) return true;
        if (needleUid && s === needleUid.toLowerCase()) return true;
        return false;
      });
    } catch (err) {
      console.warn("[SingleValueListService] isAssigneeAllowedForRole failed:", err);
      return true; 
    }
  }

  /**
   * Returns the list of assignees permitted for a role.
   * Empty array → caller should fall back to "all technicians".
   * Each item: { email, uid, label }
   */
  async getRoleAllowedAssignees(raisedByRole, { companyId = null } = {}) {
    const roleKey = String(raisedByRole || "").trim().toLowerCase();
    if (!roleKey) return [];

    try {
      const items = await this.getItems(`assignees_${roleKey}`, { companyId });
      if (!Array.isArray(items) || items.length === 0) return [];

      return items
        .map((it) => {
          const v = it?.value;
          if (v && typeof v === "object") {
            const email = String(v.email || "").trim().toLowerCase();
            const uid   = String(v.uid   || "").trim();
            if (!email && !uid) return null;
            return { email, uid, label: String(it.label || email || uid) };
          }
          const s = String(v || it?.label || "").trim();
          if (!s) return null;
          if (s.includes("@")) {
            return { email: s.toLowerCase(), uid: "", label: s };
          }
          return { email: "", uid: s, label: s };
        })
        .filter(Boolean);
    } catch (err) {
      console.error("[SingleValueListService] getRoleAllowedAssignees failed:", err);
      return [];
    }
  }

  // ── Approver helpers ───────────────────────────────────────

  async getApprovers(companyId = null) {
    const items = await this.getApproverItems(companyId);
    const emails = new Set();
    for (const it of items) {
      for (const e of it.users || []) emails.add(e);
    }
    return Array.from(emails);
  }

  async getApproverItems(companyId = null) {
    const user = this.currentUser;
    if (!companyId) companyId = user?.companyId || "";
    if (!companyId) return [];

    try {
      const lists = await this.getLists({ companyId });
      const match = lists.find((l) => isApproverList(l));
      if (!match) return [];

      const normalized = (match.items || [])
        .map((it) => {
          const rawLabel = String(it.label || "").trim();
          const v = it.value;

          if (v && typeof v === "object") {
            const level = Number(v.level);
            if (!Number.isFinite(level) || level < 1) return null;

            let users = [];
            if (Array.isArray(v.users)) {
              users = v.users
                .map((e) => String(e || "").trim().toLowerCase())
                .filter((e) => e.includes("@"));
            } else if (v.email) {
              const email = String(v.email).trim().toLowerCase();
              if (email.includes("@")) users = [email];
            }
            users = Array.from(new Set(users));
            if (users.length === 0) return null;

            const status = String(v.status || "").trim();

            return {
              label: rawLabel || `Level ${level}`,
              level,
              users,
              status: status || `Level ${level}`,
            };
          }

          const email = String(v || "").trim().toLowerCase();
          if (!email.includes("@")) return null;
          return {
            label: rawLabel || email,
            level: 1,
            users: [email],
            status: `Level 1`,
          };
        })
        .filter(Boolean)
        .sort((a, b) => a.level - b.level);

      if (normalized.length > 0) {
        const lastIdx = normalized.length - 1;
        normalized[0] = { ...normalized[0], isFirst: true };
        normalized[lastIdx] = { ...normalized[lastIdx], isLast: true };
      }

      return normalized;
    } catch (err) {
      console.error("[SingleValueListService] getApproverItems failed:", err);
      return [];
    }
  }

  async getApproversByLevel(companyId = null) {
    const items = await this.getApproverItems(companyId);
    const byLevel = new Map();
    for (const it of items) {
      if (!byLevel.has(it.level)) byLevel.set(it.level, []);
      byLevel.get(it.level).push({
        label: it.label,
        users: it.users,
        status: it.status,
      });
    }
    return byLevel;
  }

  async getApprovalChain(companyId = null) {
    const byLevel = await this.getApproversByLevel(companyId);
    return [...byLevel.keys()]
      .sort((a, b) => a - b)
      .map((lvl) => ({ level: lvl, rows: byLevel.get(lvl) }));
  }

  async getApproverStatusChain(companyId = null) {
    const items = await this.getApproverItems(companyId);
    return items.map((it) => ({
      level: it.level,
      label: it.label,
      status: it.status,
      isFirst: it.isFirst === true,
      isLast: it.isLast === true,
      users: it.users,
    }));
  }

  async setApprovers(approvers = [], companyId = null) {
    const user = this.currentUser;
    if (!companyId) companyId = user?.companyId || "";
    if (!companyId) throw new Error("Company ID is required.");

    const normalized = (Array.isArray(approvers) ? approvers : [])
      .map((a) => {
        if (typeof a === "string") {
          const email = a.trim().toLowerCase();
          if (!email.includes("@")) return null;
          return { label: email, level: 1, users: [email], status: "" };
        }

        if (!a || typeof a !== "object") return null;

        const level = Number(a.level);
        if (!Number.isFinite(level) || level < 1) return null;

        const status = String(a.status || "").trim();

        if (Array.isArray(a.users)) {
          const users = Array.from(
            new Set(
              a.users
                .map((e) => String(e || "").trim().toLowerCase())
                .filter((e) => e.includes("@")),
            ),
          );
          if (users.length === 0) return null;
          return {
            label: String(a.label || `Level ${level}`).trim(),
            level,
            users,
            status,
          };
        }

        const email = String(a.email || "").trim().toLowerCase();
        if (!email.includes("@")) return null;
        return {
          label: String(a.label || email).trim() || email,
          level,
          users: [email],
          status,
        };
      })
      .filter(Boolean)
      .sort((x, y) => x.level - y.level);

    const listId = `svl-approvers-${companyId}`;

    const payload = {
      id: listId,
      companyId,
      userId: null,
      scope: "company",
      name: APPROVER_LIST_NAME,
      items: normalized.map((n) => {
        const value = {
          level: n.level,
          users: n.users,
        };
        if (typeof n.status === "string" && n.status.trim()) {
          value.status = n.status.trim();
        }
        return { label: n.label, value };
      }),
      metadata: {
        deletedFlag: false,
        createdBy: user?.email || "system",
        modifiedBy: user?.email || "system",
      },
    };

    return await this.upsertList(listId, payload, { isCreation: true });
  }

  isApprover(email, approverEmails = []) {
    const e = String(email || "").trim().toLowerCase();
    if (!e) return false;
    return approverEmails.includes(e);
  }

  async getApproverLevelFor(email, companyId = null) {
    const items = await this.getApproverItems(companyId);
    const e = String(email || "").trim().toLowerCase();
    const matches = items.filter((it) => (it.users || []).includes(e));
    if (matches.length === 0) return null;
    return Math.min(...matches.map((m) => m.level));
  }

  canEditAsset(user, asset, { ownershipEnabled = false, bypassEmails = [] } = {}) {
    if (!user) return false;
    if (!ownershipEnabled) return true;

    const userId = user.id || user.uid || null;
    const userEmail = String(user.email || "").trim().toLowerCase();

    const ownerId = asset?.ownerId || asset?.owner?.id || null;
    const ownerEmail = String(
      asset?.ownerEmail || asset?.owner?.email || "",
    ).trim().toLowerCase();

    if (userId && ownerId && String(userId) === String(ownerId)) return true;
    if (userEmail && ownerEmail && userEmail === ownerEmail) return true;
    if (userEmail && bypassEmails.includes(userEmail)) return true;

    return false;
  }

  canViewAsset(user, asset, options) {
    return this.canEditAsset(user, asset, options);
  }

  filterVisibleAssets(user, assets = [], options) {
    if (!options?.ownershipEnabled) return assets;
    return assets.filter((a) => this.canViewAsset(user, a, options));
  }
}

export const singleValueListService = new SingleValueListService();
export default singleValueListService;